import {
    DELETE_RANDOM_DT_LOG,
    DELETE_RANDOM_DT_LOG_FAIL,
    DELETE_RANDOM_DT_LOG_SUCCESS,
    GET_RANDOM_DT_LOG_DETAILS,
    GET_RANDOM_DT_LOG_DETAILS_FAIL,
    GET_RANDOM_DT_LOG_DETAILS_SUCCESS,
    RANDOM_DT_LOG_CREATE,
    RANDOM_DT_LOG_CREATE_FAIL,
    RANDOM_DT_LOG_CREATE_SUCCESS,
    RESET,
    RESET_RANDOM_DT_LOG_CREATE,
    RESET_RANDOM_DT_LOG_DETAILS,
    UPDATE_RANDOM_DT_LOG,
    UPDATE_RANDOM_DT_LOG_FAIL,
    UPDATE_RANDOM_DT_LOG_SUCCESS,
} from "./actionsTypes";

const initialState = {
    RandomDTLogList: [],
    RandomDTLogDetails: {},
    createResult: {},
    deleteResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    error: {
        message: "",
    },
};

const RandomDTLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case RANDOM_DT_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case RANDOM_DT_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case RANDOM_DT_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        //GET individual Random DT Log
        case GET_RANDOM_DT_LOG_DETAILS:
            state = { ...state, detailsLoading: true, RandomDTLogDetails: {} };
            break;
        case GET_RANDOM_DT_LOG_DETAILS_SUCCESS:
            state = { ...state, RandomDTLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_RANDOM_DT_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        //Update individual Random DT Log
        case UPDATE_RANDOM_DT_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_RANDOM_DT_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_RANDOM_DT_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false
            };
            break;

        //Delete individual Random DT Log
        case DELETE_RANDOM_DT_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_RANDOM_DT_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_RANDOM_DT_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;

        //Reset Random DT Log
        case RESET_RANDOM_DT_LOG_DETAILS:
            state = { ...state, RandomDTLogDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, RandomDTLogList: [], createResult: {} };
            break;
        case RESET_RANDOM_DT_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default RandomDTLogReducer;